(() => {
  function initJournal(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const opener = root.querySelector('[data-search-toggle]');
    const panel = root.querySelector('#SapJournalFind');
    const input = root.querySelector('input[type="search"]');
    const cards = [...root.querySelectorAll('[data-story]')];
    const status = root.querySelector('[data-story-count]');
    let topic = '';
    function filter() {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach(card => {
        card.hidden = !((!topic || card.dataset.tags.split('|').includes(topic)) && card.dataset.title.toLocaleLowerCase().includes(query));
        if (!card.hidden) visible++;
      });
      root.querySelector('[data-no-stories]').hidden = visible > 0;
      status.textContent = visible === 1 ? status.dataset.one : status.dataset.many.replace('__N__', String(visible));
    }
    function close() {
      panel.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      input.value = '';
      filter();
      opener.focus();
    }
    opener.addEventListener('click', () => {
      if (!panel.hidden) return close();
      panel.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      input.focus();
    });
    root.querySelector('[data-search-close]').addEventListener('click', close);
    input.addEventListener('input', filter);
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    root.querySelectorAll('[data-topic]').forEach(button => button.addEventListener('click', () => {
      topic = button.dataset.topic;
      root.querySelectorAll('[data-topic]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      filter();
    }));
  }
  function initArticle(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const toc = root.querySelector('.sap-system-article__toc');
    const headings = [...root.querySelectorAll('[data-article-content] h2, [data-article-content] h3')];
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = 'sap-article-part-' + (index + 1);
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      a.addEventListener('click', () => { heading.tabIndex = -1; heading.focus({preventScroll: true}); });
      li.append(a);toc.querySelector('ul').append(li);
    });
    toc.hidden = !headings.length;
  }
  function init(scope) {
    scope.querySelectorAll('[data-journal]').forEach(initJournal);
    scope.querySelectorAll('[data-journal-article]').forEach(initArticle);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
